







































import { Component, Prop, Watch } from 'vue-property-decorator';

import isMobile from '@/utils/mobile-check';

import TopBarMenu from '@/componentsV2/atoms/TopBarMenu/TopBarMenu.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';

import BusinessMenuDropdown from './BusinessMenuDropdown.vue';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';

@Component({
  components: {
    Picture,
    BusinessMenuDropdown
  }
})
export default class BusinessMenuList extends TopBarMenu {
  @Prop() businesses!: any[];

  selectWidth: string | null = null;
  isMobileDevice = isMobile();
  menuListOffset: any = {
    top: 0,
    left: 0
  };

  get activeBusiness() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  @Watch('opened')
  changedOpened() {
    this.setMenuListOffset();
  }

  setMenuListOffset() {
    let { left, top, width } = this.$el.getBoundingClientRect();

    let offset: any = {
      left: left + width + 8
    };

    // identifying if the dropdown is in the end of the window
    if ((top / window.innerHeight) * 100 >= 65) {
      offset.bottom = 0;
    } else {
      offset.top = top;
    }

    this.menuListOffset = offset;
  }

  handleMouseEnter() {
    if (this.isMobileDevice) return;

    this.onEnterSelect();
  }

  handleClickAvatar() {
    if (this.isMobileDevice) {
      eventBus.$emit('toggleLeftBarMobile', false);
      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: 'businessMenuModal',
          hideCancelButton: false,
          icon: '',
          mobilePositionBottom: true,
          mobileFullScreen: false
        }),
        {
          businesses: this.businesses
        }
      );
      return;
    }
    this.onEnterSelect();
  }

  onEnterSelect() {
    this.showMenu();
  }

  onLeaveSelect() {
    this.leaveMenu();
  }

  created() {
    const elScroll = document.querySelector('.left-bar-visible');
    if (elScroll) {
      elScroll.addEventListener('scroll', this.setMenuListOffset);
    }
  }

  beforeDestroy() {
    const elScroll = document.querySelector('.left-bar-visible');
    if (elScroll) {
      elScroll.removeEventListener('scroll', this.setMenuListOffset);
    }
  }
}
